import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false;

require('./assets/main.scss');

Vue.use(require('vue-moment'));
// Vue.use(VueMomentLib)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
